/**
 * Get today's date in a specific timezone as YYYY-MM-DD string.
 * Falls back to Europe/Berlin if no timezone provided.
 */
export function todayInTz(tz: string = 'Europe/Berlin'): string {
  return new Date().toLocaleDateString('sv-SE', { timeZone: tz });
}

/**
 * Get the current day-of-week (0=Sun..6=Sat) in a specific timezone.
 */
export function dowInTz(tz: string = 'Europe/Berlin'): number {
  const dateStr = todayInTz(tz);
  return new Date(dateStr + 'T12:00:00').getDay();
}

/**
 * Get current time as HH:MM in a specific timezone.
 */
export function nowTimeInTz(tz: string = 'Europe/Berlin'): string {
  return new Date().toLocaleTimeString('de-DE', { timeZone: tz, hour: '2-digit', minute: '2-digit', hour12: false });
}

/**
 * Get the current hour (0-23) in a specific timezone.
 */
export function hourInTz(tz: string = 'Europe/Berlin'): number {
  return parseInt(new Date().toLocaleTimeString('en-US', { timeZone: tz, hour: '2-digit', hour12: false }), 10);
}

/**
 * Get ISO 8601 week number from a YYYY-MM-DD string.
 * Pure UTC calculation — no timezone bugs.
 */
export function getISOWeekNumber(dateStr: string): number {
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  return Math.ceil(((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}
